/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Endpoint_Header_EyebrowInputs */

const en_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform} API`)
};

const zh_hans1_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform} API`)
};

const pt_br2_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API para ${i?.platform}`)
};

const es_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API de ${i?.platform}`)
};

const fr_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.platform}`)
};

const de_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform}-API`)
};

const ru_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.platform}`)
};

const it_endpoint_header_eyebrow = /** @type {(inputs: Endpoint_Header_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API di ${i?.platform}`)
};

/**
* | output |
* | --- |
* | "{platform} API" |
*
* @param {Endpoint_Header_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_header_eyebrow = /** @type {((inputs: Endpoint_Header_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Header_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_header_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_header_eyebrow(inputs)
	if (locale === "es") return es_endpoint_header_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_header_eyebrow(inputs)
	if (locale === "de") return de_endpoint_header_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_header_eyebrow(inputs)
	if (locale === "it") return it_endpoint_header_eyebrow(inputs)
	return en_endpoint_header_eyebrow(inputs)
});